<template>
  <div class="chat-container w-100 position-relative bg-white">
    <div id="hotel-laundry-cart"></div>
    <div class="position-relative z-index-1028">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-white" :class="{'box-shadow-nav':scrollPosition >40}">
                  <div class="container px-4 w-100 py-1">
                    <div class="row no-gutters py-2 m-0 w-100">
                      <div class="col-1">
                        <div class="">
                          <router-link :to="'/'+getMerchant.code+'/concierge/laundry'">
                            <img src="../../../../assets/img/icon/back.png" class="mt-1 top-2" width="20">
                          </router-link>
                        </div>
                      </div>
                      <div class="col-8">
                        <div class="">
                          <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1">{{$t('hotel.concierge.fitur.laundry.laundry-service-request')}}</p>
                        </div>
                      </div>
                      <!-- <div class="col-3 text-right">
                        <div class="mt-1">
                          <img src="../../../../assets/img/hotel/avatar-img.jpg" width="30" height="30" class="rounded-100 object-fit d-inline-block">
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="height-50px"></div>
    <template v-if="getConciergeOrder.custom.length > 0">
      <div v-if="is_load" class="w-100 py-5 text-center">
        <loader />
      </div>
      <template v-else>
        <ErrorMessage v-if="error != ''" :message="error" />
        <template v-else>
          <!-- ROOM -->
          <div class="mt-4 mb-1 pb-4 border-b-semi-grey px-4" v-if="reservation.room && Object.keys(reservation.room).length > 0">
            <div class="w-100 p-3 bg-border-green-light radius-12">
              <p class="mb-0 body-2-1">{{$t('hotel.room')}} : {{reservation.room.name}}</p>
              <p class="mb-0 body-3-3-1">You will transact through the room</p>
            </div>
          </div>
          <div class="container px-4 mt-3 mb-3 box-shadow-primary rounded-10">
            <div class="pt-3 pb-2">
              <div class="">
                <div class="">
                  <p class="mb-3 body-3-3 text-16 font-bold">{{$t('hotel.concierge.service-selected')}} <span class="mb-0" v-if="getConciergeOrder.custom.length > 0">[{{getConciergeOrder.custom[0].type=='kilo'?'Per Kilo':'Per Pcs'}}]</span></p>
                  <div v-for="(data, index) in getConciergeOrder.custom">
                    <menuCartLaundry :data="data"></menuCartLaundry>

                    <!-- <div class="col-12">
                      <p @click="selectDetailData(data.product)" class="mb-0 body-2 font-bold text-black text-truncate">[{{data.type=='kilo'?'Per Kilo':'Per Pcs'}}] {{data.product.name}}</p>
                      <div class="row slim-grid-row">
                        <div class="col-8 text-left align-self-center">
                          <p @click="selectDetailData(data.product)" class="mb-0 body-2 font-regular text-truncate"><template v-if="data.type == 'pcs'">{{$t('hotel.concierge.start-from')}} </template>{{formatCurrency(data.product.price)}} <template v-if="data.type == 'kilo'"> / kilo</template></p>
                        </div>
                        <div class="col-4 text-right align-self-center">
                          <p class="mb-0 body-2 text-orange font-bold text-12 cursor-pointer" @click="removeConciergeOrderCustom(data.product.id)">{{$t('hotel.action.cancel')}}</p>
                        </div>
                      </div>
                    </div> -->
                  </div>
                  <router-link :to="'/'+getMerchant.code+'/concierge/laundry'">
                    <p class="mb-2 mt-3 pb-1 body-2-2 font-semibold text-green underline">+ {{$t('hotel.action.add-more')}}</p>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="container px-4 py-3 mb-4 box-shadow-primary rounded-10" id="note_section">
            <p class="mb-3 body-3-3 text-16 font-bold">{{$t('hotel.concierge.add-note')}}</p>
            <textarea v-model="note" class="form-control px-2 body-2 rounded-6 text-14 mb-2" rows="3" :placeholder="$t('hotel.concierge.note-placeholder.laundry')"></textarea>
          </div>
          <div class="mb-4 pb-4 box-shadow-primary rounded-10 px-4">
            <p class="mb-0 body-1-4">{{$t('hotel.menu.personal-data')}}</p>
            <p class="mb-2 body-2-2-1">{{$t('hotel.concierge.fitur.cart.personal-data-desc')}}</p>
            <div class="w-100 mb-3">
              <label for="form_name" class="body-3-1 mb-1 w-100">{{$t('general.your-name')}} <span class="font-weight-bold text-danger">*</span></label>
              <input 
                id="form_name" 
                type="text" 
                class="border-semi-grey radius-12 body-2-1 w-100 mb-1"
                :class="{'border-danger':form_validation.name != ''}"
                style="padding: 12px 14px;"
                v-model="customer_detail.first_name" />
                <p v-if="form_validation.name != ''" class="mb-0 body-3-3-1 text-danger"><i class="simple-icon-exclamation mr-1"></i> {{form_validation.name}}</p>
            </div>
            <div class="w-100 mb-3">
              <label for="form_email" class="body-3-1 mb-1 w-100">{{$t('hotel.concierge.fitur.cart.email-address')}} <span class="font-weight-bold text-danger">*</span></label>
              <input 
                id="form_email" 
                type="text" 
                class="border-semi-grey radius-12 body-2-1 w-100 mb-1"
                :class="{'border-danger':form_validation.email != ''}"
                style="padding: 12px 14px;"
                v-model="customer_detail.email" />
                <p v-if="form_validation.email != ''" class="mb-0 body-3-3-1 text-danger"><i class="simple-icon-exclamation mr-1"></i> {{form_validation.email}}</p>
            </div>
            <div class="w-100">
              <label for="form_phone" class="body-3-1 mb-1 w-100">{{$t('hotel.concierge.form.phone-number')}} <span class="ml-1 text-semi-light">({{$t('hotel.concierge.fitur.cart.optional')}})</span></label>
              <input 
                id="form_phone" 
                type="text" 
                class="border-semi-grey radius-12 body-2-1 w-100 mb-1"
                style="padding: 12px 14px;"
                v-model="customer_detail.phone_number" />
            </div>
            <div class="w-100">
              <label for="form_room" class="body-3-1 mb-1 w-100">Room <span class="font-weight-bold text-danger">*</span></label>
              <input 
                :disabled="reservation.room && reservation.room.id"
                id="form_room" 
                type="text" 
                class="border-semi-grey radius-12 body-2-1 w-100 mb-1"
                :class="{'border-danger':form_validation.room != ''}"
                style="padding: 12px 14px;"
                v-model="customer_detail.room" />
              <p v-if="form_validation.room != ''" class="mb-0 body-3-3-1 text-danger"><i class="simple-icon-exclamation mr-1"></i> {{form_validation.room}}</p>
            </div>
          </div>
          <div class="container px-4 pt-3 mb-3">
            <p class="mb-3 pt-4 body-3-3 text-16 font-bold">{{$t('hotel.concierge.price-detail')}}</p>
            <div class="box-shadow-primary p-3 border rounded-6 bg-light">
              <div class="row" v-if="getConciergeOrder.custom[0].type == 'kilo'">
                <div class="col-12 text-center">
                  <p class="mb-0 body-2-2 font-semibold">{{$t('hotel.concierge.laundry-price-detail')}}</p>
                </div>
              </div>
              <template v-else>
                <div class="row mb-2 pb-1" v-for="serv in getConciergeOrder.custom">
                  <div class="col-6">
                    <p class="mb-0 body-2-2 font-semibold">{{serv.service.name}}</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 body-2-2 font-semibold">{{formatCurrency(calculateTotal('service',serv.service.id))}}</p>
                  </div>
                </div>
                <div class="border-top">
                  <div class="row pt-2">
                    <div class="col-6">
                      <p class="mb-0 body-1-2 font-bold">{{$t('hotel.concierge.total')}}</p>
                    </div>
                    <div class="col-6 text-right">
                      <p class="mb-0 body-1-2 font-bold">{{formatCurrency(calculateTotal('total'))}}</p>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <!-- <div class="row no-gutters mt-2">
              <div class="col-1">
                <img src="../../../../assets/img/icon/info.png" width="14" class="">
              </div>
              <div class="col-11">
                <p class="mb-0 body-2 text-12 font-semibold pt-1">The price will appear after the clothes are weighed.</p>
              </div>
            </div> -->
          </div>
          <div class="px-4 mt-3">
            <ErrorMessage v-if="error_push != ''" :message="error_push" />
          </div>
          <div class="container p-4">
            <button @click="submitInquiry" :disabled="push_loader" type="button" class="button-primary w-100" :class="{'button-disabled': push_loader}">
              <pulse-loader :loading="push_loader" color="#fff" v-if="push_loader"></pulse-loader>
              <template v-else>
                {{$t('hotel.action.request-service')}}
              </template>
            </button>
          </div>
        </template>
      </template>
    </template>
    <template v-else>
      <div class="container px-5 text-center mt-5 pt-3">
        <img src="../../../../assets/img/icon/404.png" width="150" class="mt-2">
        <p class="mb-1 mt-3 body-2-2 font-bold text-20">{{$t('hotel.concierge.no-order')}}</p>
        <p class="mb-3 body-2-2 font-semibold">{{$t('hotel.concierge.no-order-desc.laundry')}}</p>
        <router-link :to="'/'+getMerchant.code+'/concierge/laundry'">
          <button class="button-primary text-12 px-4">{{$t('hotel.action.choose-laundry-service')}}</button>
        </router-link>
      </div>
    </template>
    <detailLaundryService v-if="detail_data != null" @close="selectDetailData" :detail_data="detail_data"></detailLaundryService>

    <warning-box 
      v-if="error_chat.show" 
      :title="$t('hotel.concierge.fitur.laundry.action-message')"
      :body="$t('hotel.concierge.fitur.laundry.error-chat')+' '+ error_chat.timer + ' ' +$t('hotel.concierge.fitur.laundry.seconds')" />
  </div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';
  import BottomNavbar from '@/components/hotel/BottomNavbar';
  import detailLaundryService from '@/components/hotel/concierge/general/detailLaundryService'
  import menuCartLaundry from '@/components/hotel/concierge/general/menuCartLaundry'
  import {post,get} from '@/services/index.js';
  import {formatCurrency} from '@/utils/index.js'
  import WarningBox from '@/components/general/WarningBox'
  import { validationMixin } from "vuelidate";
  const { required, email } = require("vuelidate/lib/validators");

  export default{
    components: {
      BottomNavbar,
      detailLaundryService,
      menuCartLaundry,
      WarningBox
    },
    metaInfo(){
      return {
        title: this.$t('hotel.concierge.fitur.laundry.laundry-service-request'),
        titleTemplate: this.getMetaTitleTemplate
      }
    },
    data() {
      return {
        is_load: true,
        error: '',
        general_data: '',
        scrollPosition: null,
        is_popup: '',
        is_cart: false,
        counter: 1,
        detail_menu: {},
        detail_data: null,
        push_loader: false,
        note: '',
        error_push: '',
        error_chat: {
          show: false,
          timer: 0
        },
        customer_detail:{
          first_name: '',
          email: '',
          phone_number: '',
          room: ''
        },
        form_validation:{
          name: '',
          email: '',
          room: ''
        },
        reservation: {}
      }
    },
    mixins: [validationMixin],
    validations: {
      customer_detail:{
        first_name:{
          required
        },
        email:{
          required,
          email
        },
        room:{
          required
        }
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getConciergeOrder',
        'getMetaTitleTemplate',
        'getUpsellRef', 
        'isReservationActive',
        'getReservationActive',
        'getCurrentUser',
        'isLoggedIn',
        'isMembershipRewardApplied'
      ]),
      show_error_chat(){
        return this.error_chat.show
      }
    },
    watch:{
      show_error_chat(){
        if (this.error_chat.show) {
          let looping = setInterval(() => {
            if (this.error_chat.timer > 0) {
              this.error_chat.timer--
            }else if(this.error_chat.timer == 0){
              this.error_chat.show = false
              clearInterval(looping)
              this.resetConciergeOrder()
              this.$router.push('/'+this.getMerchant.code+'/concierge/laundry/success?total='+res.data.total_payment)
            }
          },1000) 
        }
      }
    },
    methods: {
      ...mapMutations(['removeConciergeOrderCustom','resetConciergeOrder','setReservationActive']),
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      selectDetailData(data='reset'){
        if(data == 'reset'){
          this.detail_data = null
        }else{
          if(typeof(data.product_list) != undefined){
            this.detail_data = data
          }else{
            this.detail_data = null
          }
        }
      },
      calculateTotal(type,service_id){
        if(type=='service'){
          let record_service = this.getConciergeOrder.custom.findIndex(x=>x.service.id == service_id)
          if(record_service != -1){
            let service = this.getConciergeOrder.custom[record_service]
            let total = 0
            for(let i = 0; i < service.product.length; i++){
              total += (Number(service.product[i].data.price)*Number(service.product[i].qty))
            }
            return total
          }else{
            return 0
          }
        }else{
          let total = 0
          let cart = this.getConciergeOrder.custom
          for(let i = 0; i < cart.length; i++){
            for(let j = 0; j < cart[i].product.length; j++){
              total += (Number(cart[i].product[j].data.price)*Number(cart[i].product[j].qty))
            }
          }
          return total
        }
      },
      scrollTo(id){
        document.getElementById(id).scrollIntoView({
          behavior: 'smooth'
        });
      },
      fillCustomerData(with_rsv=true){
        if(with_rsv){
          this.customer_detail = {
            first_name: this.reservation.guest_profile.name,
            email: this.reservation.guest_profile.email,
            phone_number: this.reservation.guest_profile.phone
          }
          if(this.reservation.room.id){
            this.customer_detail.room = this.reservation.room.name
          }
        }else{
          let name = this.$isNotEmpty(this.getCurrentUser.last_name) ? `${this.getCurrentUser.first_name} ${this.getCurrentUser.last_name}` : this.getCurrentUser.first_name
          this.customer_detail = {
            first_name: name,
            email: this.getCurrentUser.email,
            phone_number: this.getCurrentUser.phone
          }
        }
      },
      loadFirstData(){
        this.is_load = true
        this.error = ''
        let func_exc = [this.loadGeneralSetting()]
        if(this.isReservationActive){
          func_exc.push(this.loadDetailReservation())
        }
        Promise.all(func_exc)
          .then(()=>{
            if(!this.isReservationActive && this.isLoggedIn){
              this.fillCustomerData(false)
            }
          })
          .catch(err=>this.error = err)
          .finally(()=>this.is_load = false)
      },
      loadGeneralSetting(){
        return new Promise((success,fail)=>{
          this.general_data = {}  
          get("CONCIERGE","laundry/general",{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.general_data = res.data
              success()
            }else{
              fail(res.message)
            }
          })
        })
      },
      loadDetailReservation(){
				return new Promise((success,fail)=>{
          get("CONCIERGE",`reservation/${this.getReservationActive.detail_id}`,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
						let res = response.data
            if(res.success){
							let resv = res.data
							if(this.$isReservationValid(resv)){
								this.reservation = resv
                this.fillCustomerData()
							} else{
								this.setReservationActive('reset')
							}
              success()
            }else{
              fail(res.message)
            }
          })
        })
			},
      validateForm(){
        this.form_validation = {
          name: false,
          email: false
        }
        if(this.$v.customer_detail.first_name.$invalid){
          this.form_validation.name = this.$t('hotel.concierge.fitur.validation.please-input-your-name')
          this.scrollTo('note_section')
        }
        if(this.$v.customer_detail.email.$invalid){
          if(!this.$v.customer_detail.email.required){
            this.form_validation.email = this.$t('hotel.concierge.fitur.validation.please-input-your-email-address')
          }else if(!this.$v.customer_detail.email.email){
            this.form_validation.email = this.$t('hotel.concierge.fitur.validation.incorrect-email')
          }else{
            this.form_validation.email = ''
          }
          this.scrollTo('note_section')
        }
        if(!this.$v.customer_detail.first_name.$invalid && !this.$v.customer_detail.email.$invalid){
          return true
        }else{
          return false
        }
      },
      submitInquiry(){
         if(!this.push_loader){
          this.push_loader = true
          this.error_push = ''
          if(this.validateForm()){

            let getRoomId = () => {
              return this.isReservationActive && Object.keys(this.reservation.room).length > 0 ? this.reservation.room.id : ''
            }
            
            let params = {
              merchant_id: this.getMerchant.id,
              products:[],
              customer_detail: this.customer_detail,
              room_id: getRoomId(),
              merchant_pos_id: this.general_data.merchant_pos_id,
              notes: this.note,
              region: '',
              device: this.$getDeviceType(),
              promo_code: this.getConciergeOrder.promo_code,
              campaign_id: this.getUpsellRef.id != '' && this.getUpsellRef.type == 'CAMPAIGN' ? this.getUpsellRef.id : '',
              guest_journey_id: this.getUpsellRef.id != '' && this.getUpsellRef.type == 'GUEST_JOURNEY' ? this.getUpsellRef.id : '',
              reservation_id: this.reservation.id ? this.reservation.id : null  
            }

            if(this.isMembershipRewardApplied){
              params.membership_reward_id = this.getMembershipRewardApplied.id
            }

            for(let cart of this.getConciergeOrder.custom){
              if(cart.type == 'pcs'){
                for(let prod of cart.product){
                  let product = {
                    id: prod.data.id,
                    qty: prod.qty,
                    notes: prod.notes
                  }
                  params.products.push(product)
                }
              }else{
                let product = {
                  id: cart.service.id,
                  qty: 1,
                  notes: cart.notes
                }
                params.products.push(product)
              }
            }

            post("CORE_HOTEL","merchant-pos/tx-inquiry",params).then(response=>{
              let res = response.data
              if(res.success){
                this.resetConciergeOrder()
                this.$router.push(`/${this.getMerchant.code}/concierge/trx-result/${res.data.id}`)
              }else{
                this.error_push = res.message
                this.push_loader = false
              }
            })
          }else{
            this.push_loader = false
          }
        }
      },
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
      document.getElementById('hotel-laundry-cart').scrollIntoView({
        behavior: 'smooth'
      });
      this.loadFirstData()
    }
  }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/laundry/LaundryCart.vue